import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import { CONTACT } from '../mock';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export default function ContactSection() {
  const [form, setForm] = useState({ name: '', email: '', company: '', role: '', message: '' });
  const [sending, setSending] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Required fields missing', { description: 'Full Name, Email and Message are required.' });
      return;
    }
    setSending(true);
    setTimeout(() => {
      setSending(false);
      toast.success('Inquiry received', { description: 'We will respond within 72 hours.' });
      setForm({ name: '', email: '', company: '', role: '', message: '' });
    }, 900);
  };

  return (
    <section id="contact-cta" className="section-pad relative">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 50%, rgba(8,7,5,0.55) 0%, rgba(8,7,5,0.4) 60%, rgba(8,7,5,0.7) 100%)",
        }}
      />
      <div className="absolute inset-0 crosshair-grid opacity-20" />
      <div className="container-narrow relative">
        <SectionHeader chapter={CONTACT.chapter} label="FIRST-LOOK SLOT" heading={CONTACT.heading} />
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="font-serif text-[19px] leading-[1.75] text-[color:var(--bx-bone)]/85 mb-8">{CONTACT.body}</p>
            <div className="glass-panel p-6 space-y-4">
              <div className="flex items-start justify-between gap-6">
                <div className="font-sc text-[10px] gold-text tracking-[0.4em]">RESPONSE</div>
                <div className="font-serif text-[15px] text-[color:var(--bx-bone)]/85 text-right">Within 72 hours</div>
              </div>
              <div className="flex items-start justify-between gap-6">
                <div className="font-sc text-[10px] gold-text tracking-[0.4em]">SLOTS</div>
                <div className="font-serif text-[15px] text-[color:var(--bx-bone)]/85 text-right">1 Co-Production · 1 Distribution</div>
              </div>
              <div className="flex items-start justify-between gap-6">
                <div className="font-sc text-[10px] gold-text tracking-[0.4em]">DECK</div>
                <div className="font-serif text-[15px] text-[color:var(--bx-bone)]/85 text-right">Full + Budget Breakdown</div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-7">
            <form onSubmit={submit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="font-sc text-[10px] gold-text tracking-[0.4em] mb-1 block">FULL NAME *</label>
                  <input className="input-line" value={form.name} onChange={update('name')} placeholder="Your full name" />
                </div>
                <div>
                  <label className="font-sc text-[10px] gold-text tracking-[0.4em] mb-1 block">EMAIL *</label>
                  <input type="email" className="input-line" value={form.email} onChange={update('email')} placeholder="you@studio.com" />
                </div>
                <div>
                  <label className="font-sc text-[10px] gold-text tracking-[0.4em] mb-1 block">COMPANY / STUDIO</label>
                  <input className="input-line" value={form.company} onChange={update('company')} placeholder="Studio name" />
                </div>
                <div>
                  <label className="font-sc text-[10px] gold-text tracking-[0.4em] mb-1 block">ROLE</label>
                  <input className="input-line" value={form.role} onChange={update('role')} placeholder="Producer / Distributor / Investor" />
                </div>
              </div>
              <div>
                <label className="font-sc text-[10px] gold-text tracking-[0.4em] mb-1 block">MESSAGE *</label>
                <textarea rows={4} className="input-line resize-none" value={form.message} onChange={update('message')} placeholder="Tell us why this slot belongs to you." />
              </div>
              <div className="flex items-center justify-between flex-wrap gap-4 pt-2">
                <span className="font-sc text-[10px] text-[color:var(--bx-muted)] tracking-[0.32em]">{CONTACT.note}</span>
                <button type="submit" disabled={sending} className="btn-solid-gold">
                  {sending ? 'TRANSMITTING\u2026' : 'SUBMIT INQUIRY'} <ArrowRight size={14} />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
